import { render, staticRenderFns } from "./activityStudentProfile.html?vue&type=template&id=40d06eda&scoped=true&external"
import script from "./activityStudentProfile.vue?vue&type=script&lang=js"
export * from "./activityStudentProfile.vue?vue&type=script&lang=js"
import style0 from "./activityStudentProfile.css?vue&type=style&index=0&id=40d06eda&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d06eda",
  null
  
)

export default component.exports